module.exports = __webpack_public_path__ + "img/mw.852684d1.png";